import React from "react";
import DescriptionView from "./DescriptionView";
import DetailsView from "./DetailsView";
import EmployementTermsView from "./EmployementTermsView";
import JobDocTable from "../add/details/JobDocTable";

function ViewList() {
  return (
    <div className="dark_card py-[2rem]">
      <DescriptionView />
      <DetailsView />
      <EmployementTermsView />
      <JobDocTable />
    </div>
  );
}

export default ViewList;
